<admin-app-header></admin-app-header>
<app-prospecting-nav></app-prospecting-nav>

<div class="timeline-page">
    <div class="toolbar">
        <div class="toolbar-left">
            <h1><i class="fa-solid fa-clock-rotate-left"></i> Activity Timeline</h1>
            <span class="count-badge">{{ filteredInteractions.length | number }} interactions</span>
        </div>
        <div class="toolbar-filters">
            <select [(ngModel)]="filterType">
                <option value="">All types</option>
                <option *ngFor="let t of interactionTypes" [value]="t">{{ interactionTypeLabels[t] }}</option>
            </select>
            <input type="text" placeholder="Filter by user..." [(ngModel)]="filterUser" />
            <input type="text" placeholder="Filter by company..." [(ngModel)]="filterCompany" />
        </div>
    </div>

    <div class="loading-state" *ngIf="loading">
        <i class="fa-solid fa-spinner fa-spin"></i> Loading interactions...
    </div>

    <div class="empty-state" *ngIf="!loading && !filteredInteractions.length">
        <i class="fa-solid fa-stream"></i>
        <p>No interactions found.</p>
    </div>

    <div class="card" *ngIf="!loading && filteredInteractions.length">
        <div class="timeline-list">
            <div class="timeline-item" *ngFor="let interaction of filteredInteractions">
                <div class="timeline-icon">
                    <i [class]="interactionTypeIcons[interaction.type]"></i>
                </div>
                <div class="timeline-content">
                    <div class="timeline-header">
                        <span class="type-label">{{ interactionTypeLabels[interaction.type] }}</span>
                        <span class="timestamp">{{ formatDate(interaction.createdAt) }}</span>
                    </div>
                    <div class="timeline-summary">{{ interaction.summary }}</div>
                    <div class="timeline-meta">
                        <span *ngIf="interaction.denormProspectName">
                            <i class="fa-solid fa-building"></i> {{ interaction.denormProspectName }}
                        </span>
                        <span *ngIf="interaction.denormContactName">
                            <i class="fa-solid fa-user"></i> {{ interaction.denormContactName }}
                        </span>
                        <span *ngIf="interaction.denormCreatedByName">
                            <i class="fa-solid fa-pen"></i> {{ interaction.denormCreatedByName }}
                        </span>
                    </div>
                    <div class="timeline-detail" *ngIf="interaction.type === 'EMAIL' && interaction.emailSubject">
                        <i class="fa-solid fa-envelope-open-text"></i> Subject: {{ interaction.emailSubject }}
                    </div>
                    <div class="timeline-detail" *ngIf="interaction.type === 'STATUS_CHANGE' && interaction.previousStatus">
                        <i class="fa-solid fa-arrow-right"></i> {{ interaction.previousStatus }} → {{ interaction.newStatus }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
